import { AppTheme } from '../types/theme';
import { COLORS } from '../variables/colors';

export const defaultThemeConfig: AppTheme = {
  palette: {
    primary: { main: COLORS.main, light: COLORS.light, dark: COLORS.dark },
    secondary: { main: COLORS.mainSecondary, light: COLORS.lightSecondary, dark: COLORS.darkSecondary },
    background: {
      default: 'white'
    },
    brand: {
      black: COLORS.black,
      white: COLORS.white,
      blue: COLORS.blue,
      yellow: COLORS.yellow,
      pink: COLORS.pink,
      orange: COLORS.orange,
      lightBlue: COLORS.lightBlue,
      lightGray: COLORS.lightGray
    }
  },
  backgroundColor: 'white'
};
